import {minLength, required, email, requiredIf, or, maxLength} from "@vuelidate/validators";

export const captchaValidation = {
    required: requiredIf(function () {
        return this.$store.getters['Captcha/getCaptchaStatus'];
    }),
    minLength: minLength(4), maxLength: maxLength(4)
}
